// extracted by mini-css-extract-plugin
export default {"psiAndTorqueDropDown":"styles_psiAndTorqueDropDown__HDKjB"};